import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class TimelineComponent extends ThemeComponent {
    private items = this.querySelectorAll('.timeline__item');
    private siteHeader:HTMLElement | null  = document.querySelector('.site-header');
    private timelineHeader:HTMLElement | null = this.querySelector('.timeline__heading');
    private timelineDot:HTMLElement | null = this.querySelector('.timeline__dot');

    init() {
        this.timelineTrail();

        this.$listen(window, 'resize', (e) => {
            this.timelineTrail();
        });
    }

    timelineTrail() {
        const timelineHeader = this.timelineHeader ? this.timelineHeader.offsetHeight : 0;
        const stickyOffset = this.siteHeader ? this.siteHeader.offsetHeight : 0;
        const totalOffset = timelineHeader + stickyOffset;

        if ( this.timelineDot) { this.timelineDot.style.top = `${totalOffset}px`; }
    }

    isElementInViewport(el: Element) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}
